import React from 'react';

const overlayStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  panel: {
    backgroundColor: 'var(--primary-color)',
    padding: '20px',
    borderRadius: '8px',
    width: '2000px',
    maxHeight: '80vh',
    overflowY: 'auto',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    position: 'relative',
    color: 'var(--primary-white-color)',
  },
  closeButton: {
    position: 'absolute',
    top: '5px',
    right: '5px',
    border: 'none',
    background: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    color: 'var(--primary-white-color)',
  },
};

const ProfileOverlay = ({profile, onClose }) => {

  return (
    <div style={overlayStyles.overlay} onClick={onClose}>
      <div style={overlayStyles.panel} onClick={(e) => e.stopPropagation()}>
        <button style={overlayStyles.closeButton} onClick={onClose}>X</button>
        <h3>{profile.data.name}</h3>
        <p style={{fontSize: '16px', textAlign: 'justify'}}>
          {profile.data.description}
        </p>
      </div>
    </div>
  );
};

export default ProfileOverlay; 